module.exports = __webpack_public_path__ + "img/croissant-icon.f659ce4a.svg";